<template>
  <div class="news-item">
    <a :href="item.url">
      <time class="news-item__date" :datetime="item.postDateUTC">{{ item.postDateFormatted }}</time>
      <img :src="item.image.url" :alt="item.image.title" />
      <h4 class="news-item__title">{{ item.title }}</h4>
    </a>
  </div>
</template>

<script>
export default {
  name: 'NewsItem',

  props: {
    item: Object
  }
}
</script>
